var React = require('react');

function Twitter (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M25.95 2.382c-.974.406-2.005.674-3.061.795A5.143 5.143 0 0025.232.385c-1.03.569-2.172.983-3.388 1.214A5.427 5.427 0 0018.821.068a5.593 5.593 0 00-3.383.528 5.169 5.169 0 00-2.343 2.369 4.796 4.796 0 00-.333 3.23C8.33 5.995 4.406 3.981 1.777.938a4.743 4.743 0 00-.722 2.537c0 1.754.943 3.295 2.37 4.2a5.544 5.544 0 01-2.413-.632v.062c0 1.165.425 2.294 1.204 3.197a5.394 5.394 0 003.07 1.752c-.781.198-1.6.228-2.396.087a5.08 5.08 0 001.902 2.508 5.547 5.547 0 003.086.996c-1.886 1.4-4.214 2.16-6.61 2.158-.423 0-.844-.024-1.268-.069A15.794 15.794 0 008.187 20c9.807 0 15.164-7.686 15.164-14.339 0-.215 0-.43-.016-.646A10.463 10.463 0 0026 2.403l-.05-.02z","fill":"#fff"}));
}

Twitter.defaultProps = {"fill":"none","viewBox":"0 0 26 20"};

module.exports = Twitter;

Twitter.default = Twitter;
